/**
 * displays the page where users edit the employer profile page
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EditableHeader from './components/EditableHeader';
import EditableTopBar from './components/EditableTopBar';
import EditableInfo from './components/EditableInfo';
import AdCollection from '../../components/employerProfile/AdCollection';
import VideoCollection from './components/VideoCollection';
import AmbassadorContainer from './components/ambassador/AmbassadorContainer';
import EditImages from './components/images/EditImages';
import NoAccess from '../../components/messages/NoAccess';
import Spinner from '../../components/gfx/Spinner';
import PublishContainer from './components/PublishContainer';

import './edit-profile.css';

class EditProfileUI extends Component {
    static propTypes = {
        ads: PropTypes.object,
        dispatch: PropTypes.func.isRequired,
        errorMsg: PropTypes.string,
        loadingProfileBackground: PropTypes.bool,
        loadingProfileLogo: PropTypes.bool,
        onPreviewClick: PropTypes.func.isRequired,
        onRequestPublish: PropTypes.func.isRequired,
        onRequestUnpublish: PropTypes.func.isRequired,
        onUpdateField: PropTypes.func.isRequired,
        onUploadLogo: PropTypes.func.isRequired,
        profile: PropTypes.shape({
            error: PropTypes.shape({
                status: PropTypes.number.isRequired,
            }),
            profile: PropTypes.shape({
                ambassadors: PropTypes.object,
                id: PropTypes.number.isRequired,
                images: PropTypes.object.isRequired,
                videos: PropTypes.object.isRequired,
            }),
            profileErrors: PropTypes.object,
        }).isRequired,
    };

    render() {
        if (
            this.props.profile.error &&
            this.props.profile.error.status === 403
        ) {
            return <NoAccess />;
        }

        if (!this.props.profile.profile || !this.props.profile.profile.id) {
            // Need this guard as long as we lazy load the profile!
            return (
                <div className="loadingSpinner">
                    <Spinner />
                </div>
            );
        }

        return (
            <React.Fragment>
                <EditableTopBar
                    loadingProfileLogo={this.props.loadingProfileLogo}
                    onUpdateField={this.props.onUpdateField}
                    onUploadLogo={this.props.onUploadLogo}
                    profile={this.props.profile.profile}
                />

                <EditableHeader
                    loadingProfileBackground={
                        this.props.loadingProfileBackground
                    }
                    onUpdate={this.props.onUpdateField}
                    profile={this.props.profile.profile}
                />

                <EditableInfo
                    onUpdateField={this.props.onUpdateField}
                    profile={this.props.profile.profile}
                />

                <hr className="u-mv32" />

                <VideoCollection
                    profileId={this.props.profile.profile.id}
                    videos={this.props.profile.profile.videos}
                />

                <hr className="u-mv32" />

                <EditImages
                    errorMsg={this.props.errorMsg}
                    images={this.props.profile.profile.images}
                    profileId={this.props.profile.profile.id}
                />

                <hr className="u-mv32" />

                <AmbassadorContainer
                    ambassadors={this.props.profile.profile.ambassadors}
                    profileId={this.props.profile.profile.id}
                />

                <hr className="u-mv32" />

                <AdCollection
                    ads={this.props.ads}
                    dispatch={this.props.dispatch}
                    editMode
                />

                <hr className="u-mv32" />

                <PublishContainer
                    onPreviewClick={this.props.onPreviewClick}
                    onRequestPublish={this.props.onRequestPublish}
                    onRequestUnpublish={this.props.onRequestUnpublish}
                    profile={this.props.profile}
                    profileErrors={this.props.profile.profileErrors}
                />
            </React.Fragment>
        );
    }
}

export default EditProfileUI;
